import { request } from '@/shared/api';
import { withScopeQuery } from '@/shared/model/agent-scope';
export function fetchAgents(scope, options) {
    const limit = options?.limit ?? 500;
    return request(withScopeQuery(`/api/v1/agents?limit=${limit}`, scope));
}
export function fetchAgent(agentId, scope) {
    return request(withScopeQuery(`/api/v1/agents/${encodeURIComponent(agentId)}`, scope));
}
export function fetchAgentDirectoryMetrics(agentIds) {
    if (agentIds.length === 0) {
        return Promise.resolve({ items: [] });
    }
    const ids = agentIds.map(encodeURIComponent).join(',');
    return request(`/api/v1/agent-directory/metrics?ids=${ids}`);
}
export function createAgent(input) {
    return request('/api/v1/agents', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function fetchAgentHub(agentId, scope) {
    return request(withScopeQuery(`/api/v1/agents/${encodeURIComponent(agentId)}/hub`, scope));
}
export async function fetchAgentBmQuestionnaire(agentId, scope) {
    const response = await request(withScopeQuery(`/api/v1/agents/${encodeURIComponent(agentId)}/bm-questionnaire`, scope));
    return response.questionnaire;
}
export function fetchAgentLeads(agentId, options) {
    const inWork = options?.inWorkOnly === false ? 'false' : 'true';
    return request(withScopeQuery(`/api/v1/agents/${encodeURIComponent(agentId)}/leads?inWork=${inWork}`, options?.scope));
}
export function fetchAgentTouchpoints(agentId, scope) {
    return request(withScopeQuery(`/api/v1/agents/${encodeURIComponent(agentId)}/touchpoints`, scope));
}
export function fetchAgentRatingDetail(agentId, scope) {
    return request(withScopeQuery(`/api/v1/agents/${encodeURIComponent(agentId)}/rating-detail`, scope));
}
export function fetchAgentTelegramProfile(agentId, scope) {
    return request(withScopeQuery(`/api/v1/agents/${encodeURIComponent(agentId)}/telegram-profile`, scope));
}
export function refreshAgentTelegramProfile(agentId, scope) {
    return request(withScopeQuery(`/api/v1/agents/${encodeURIComponent(agentId)}/telegram-profile/refresh`, scope), { method: 'POST' });
}
export function createAgentEngagement(input) {
    return request('/api/v1/agent-engagements', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function setAgentExternalRating(input) {
    return request(`/api/v1/agents/${encodeURIComponent(input.agentId)}/external-rating`, {
        method: 'PUT',
        body: JSON.stringify({ externalRating: input.externalRating }),
    });
}
export function fetchAgentEngagementByNumber(number) {
    const params = new URLSearchParams({ number });
    return request(`/api/v1/agent-engagements/by-number?${params.toString()}`);
}
export function fetchCycleBoard(input) {
    const params = new URLSearchParams({ view: input.view });
    if (input.status)
        params.set('status', input.status);
    if (input.scope)
        params.set('scope', input.scope);
    return request(`/api/v1/agent-engagements/board?${params.toString()}`);
}
export function fetchProjectMatrix(input) {
    const params = new URLSearchParams();
    if (input?.scope)
        params.set('scope', input.scope);
    const suffix = params.size > 0 ? `?${params.toString()}` : '';
    return request(`/api/v1/agent-engagements/project-matrix${suffix}`);
}
export function fetchAgenciesDirectory(input) {
    const params = new URLSearchParams();
    if (input?.scope)
        params.set('scope', input.scope);
    if (input?.q?.trim())
        params.set('q', input.q.trim());
    const suffix = params.size > 0 ? `?${params.toString()}` : '';
    return request(`/api/v1/agencies${suffix}`);
}
export function createAgencyDirectory(input) {
    return request('/api/v1/agencies', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function renameAgencyDirectory(crmAgencyId, input) {
    return request(`/api/v1/agencies/${encodeURIComponent(crmAgencyId)}`, {
        method: 'PATCH',
        body: JSON.stringify(input),
    });
}
export function searchAgencyCandidates(cycleId, query) {
    const params = new URLSearchParams();
    if (query.trim())
        params.set('q', query.trim());
    const suffix = params.size > 0 ? `?${params.toString()}` : '';
    return request(`/api/v1/agent-engagements/${encodeURIComponent(cycleId)}/agency-candidates${suffix}`);
}
export function reviewAgencyDirectory(crmAgencyId, query) {
    const params = new URLSearchParams();
    if (query.trim())
        params.set('q', query.trim());
    const suffix = params.size > 0 ? `?${params.toString()}` : '';
    return request(`/api/v1/agencies/${encodeURIComponent(crmAgencyId)}/review${suffix}`);
}
export function confirmAgencyLink(cycleId, input) {
    return request(`/api/v1/agent-engagements/${encodeURIComponent(cycleId)}/agency-link`, { method: 'POST', body: JSON.stringify(input) });
}
export function confirmAgencyDirectoryLink(crmAgencyId, input) {
    return request(`/api/v1/agencies/${encodeURIComponent(crmAgencyId)}/link`, { method: 'POST', body: JSON.stringify(input) });
}
export function revokeAgencyLink(cycleId, input) {
    return request(`/api/v1/agent-engagements/${encodeURIComponent(cycleId)}/agency-link/revoke`, { method: 'POST', body: JSON.stringify(input) });
}
export function revokeAgencyDirectoryLink(crmAgencyId, input) {
    return request(`/api/v1/agencies/${encodeURIComponent(crmAgencyId)}/link/revoke`, { method: 'POST', body: JSON.stringify(input) });
}
export function closeAgentEngagement(id, input) {
    return request(`/api/v1/agent-engagements/${encodeURIComponent(id)}/close`, {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function fetchCycleFeed(id) {
    return request(`/api/v1/agent-engagements/${encodeURIComponent(id)}/feed`);
}
export function createCycleTask(id, input) {
    return request(`/api/v1/agent-engagements/${encodeURIComponent(id)}/tasks`, {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function fetchEventsCatalog(input) {
    const params = new URLSearchParams();
    if (input?.q)
        params.set('q', input.q);
    if (input?.format)
        params.set('format', input.format);
    if (input?.project)
        params.set('project', input.project);
    if (input?.period)
        params.set('period', input.period);
    if (input?.limit != null)
        params.set('limit', String(input.limit));
    if (input?.offset != null)
        params.set('offset', String(input.offset));
    const query = params.toString();
    return request(`/api/v1/events${query ? `?${query}` : ''}`);
}
export function fetchEventCatalogItem(id) {
    return request(`/api/v1/events/${encodeURIComponent(id)}`);
}
export function fetchPriorityList(input) {
    const params = new URLSearchParams();
    if (input?.q)
        params.set('q', input.q);
    if (input?.group)
        params.set('group', input.group);
    if (input?.status)
        params.set('status', input.status);
    const query = params.toString();
    return request(`/api/v1/priority${query ? `?${query}` : ''}`);
}
export function fetchPriorityItem(id) {
    return request(`/api/v1/priority/${encodeURIComponent(id)}`);
}
export function confirmPriorityLink(id, agentId) {
    return request(`/api/v1/priority/${encodeURIComponent(id)}/link`, {
        method: 'POST',
        body: JSON.stringify({ agentId }),
    });
}
export function revokePriorityLink(id) {
    return request(`/api/v1/priority/${encodeURIComponent(id)}/link/revoke`, {
        method: 'POST',
        body: JSON.stringify({}),
    });
}
